// エラーコードの型定義
export type ErrorCode =
  // HTTPエラー
  | 'BAD_REQUEST'
  | 'UNAUTHORIZED'
  | 'FORBIDDEN'
  | 'NOT_FOUND'
  | 'REQUEST_TIMEOUT'
  | 'TOO_MANY_REQUESTS'
  | 'INTERNAL_SERVER_ERROR'
  | 'BAD_GATEWAY'
  | 'SERVICE_UNAVAILABLE'
  | 'GATEWAY_TIMEOUT'
  // バリデーションエラー
  | 'VALIDATION_ERROR'
  // ネットワークエラー
  | 'NETWORK_ERROR'
  | 'REQUEST_FAILED'
  // 認証エラー
  | 'AUTH_EXPIRED'
  | 'AUTH_REFRESH_FAILED'
  | 'LOGIN_ERROR'
  // ユーザー関連エラー
  | 'UPDATE_PROFILE_ERROR'
  | 'UPDATE_USER_ERROR'
  | 'CREATE_USER_ERROR'
  | 'DELETE_USER_ERROR'
  // その他
  | 'UNKNOWN_ERROR'
  | 'LOGOUT_ERROR'
  | 'USER_CREATE_ERROR'
  | 'API_ERROR'
  | 'COOKIE_PARSE_ERROR'
  | 'FETCH_TONES_ERROR'
  | 'INVALID_HEADING_LEVEL'
  | 'USER_INFO_NOT_FOUND'
  | 'ARTICLE_CREATE_ERROR'
  | 'USER_UPDATE_ERROR'
  | 'HEADING_CREATE_ERROR'
  | 'ARTICLE_PROCESS_ERROR';

/**
 * エラーハンドラーの型定義
 * @param error - エラーオブジェクト
 * @param errorCode - エラーコード
 */
export type ErrorHandler = (error: unknown, errorCode: ErrorCode) => void;

// HTTPステータスコードとエラーコードのマッピング
export const HTTP_STATUS_TO_ERROR_CODE: Record<number, ErrorCode> = {
  400: 'BAD_REQUEST',
  401: 'UNAUTHORIZED',
  403: 'FORBIDDEN',
  404: 'NOT_FOUND',
  408: 'REQUEST_TIMEOUT',
  429: 'TOO_MANY_REQUESTS',
  500: 'INTERNAL_SERVER_ERROR',
  502: 'BAD_GATEWAY',
  503: 'SERVICE_UNAVAILABLE',
  504: 'GATEWAY_TIMEOUT',
  422: 'VALIDATION_ERROR',
} as const;

// エラーメッセージの定義
export const ERROR_MESSAGES: Record<ErrorCode, string> = {
  // HTTPエラー
  BAD_REQUEST: 'リクエストが不正です',
  UNAUTHORIZED: '認証が必要です',
  FORBIDDEN: 'アクセスが拒否されました',
  NOT_FOUND: 'リソースが見つかりません',
  REQUEST_TIMEOUT: 'リクエストがタイムアウトしました',
  TOO_MANY_REQUESTS: 'リクエストが多すぎます',
  INTERNAL_SERVER_ERROR: 'サーバーエラーが発生しました',
  BAD_GATEWAY: 'ゲートウェイエラーが発生しました',
  SERVICE_UNAVAILABLE: 'サービスが利用できません',
  GATEWAY_TIMEOUT: 'ゲートウェイがタイムアウトしました',
  // バリデーションエラー
  VALIDATION_ERROR: '入力内容に誤りがあります',
  // ネットワークエラー
  NETWORK_ERROR: 'ネットワークエラーが発生しました',
  REQUEST_FAILED: 'リクエストが失敗しました',
  // 認証エラー
  AUTH_EXPIRED: '認証の有効期限が切れました',
  AUTH_REFRESH_FAILED: '認証の更新に失敗しました',
  LOGIN_ERROR: 'ログインに失敗しました',
  // ユーザー関連エラー
  UPDATE_PROFILE_ERROR: 'プロフィールの更新に失敗しました',
  UPDATE_USER_ERROR: 'ユーザー情報の更新に失敗しました',
  CREATE_USER_ERROR: 'ユーザーの作成に失敗しました',
  DELETE_USER_ERROR: 'ユーザーの削除に失敗しました',
  // その他
  UNKNOWN_ERROR: '予期せぬエラーが発生しました',
  LOGOUT_ERROR: 'ログアウト中にエラーが発生しました',
  USER_CREATE_ERROR: 'ユーザーの作成に失敗しました。入力内容を確認してください。',
  API_ERROR: 'APIでエラーが発生しました',
  COOKIE_PARSE_ERROR: 'クッキーのデータの解析に失敗しました',
  FETCH_TONES_ERROR: 'トーンの取得に失敗しました',
  INVALID_HEADING_LEVEL: 'h1は使用できません。h2またはh3を使用してください。',
  USER_INFO_NOT_FOUND: 'ユーザー情報が見つかりません',
  ARTICLE_CREATE_ERROR: '記事の作成中にエラーが発生しました',
  USER_UPDATE_ERROR: 'ユーザー情報の更新に失敗しました',
  HEADING_CREATE_ERROR: '見出しの作成に失敗しました',
  ARTICLE_PROCESS_ERROR: '記事の生成処理の開始に失敗しました'
};
